var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('div',{staticClass:"nav nav-tabs nav-wrapper",attrs:{"id":"nav-tab","role":"tablist"}},[_c('a',{staticClass:"nav-item nav-link active",attrs:{"id":"nav-home-tab","data-toggle":"tab","href":"#nav-home","role":"tab","aria-controls":"nav-home","aria-selected":"true"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("extra")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e73f6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavItemBlock.vue
// module id = null
// module chunks = 